import makeStyles from '@material-ui/core/styles/makeStyles';
import ImageDisplay from '../ImageDisplay';
import OptionalCard from './OptionalCard';

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      marginBottom: 12,
    },
    content: {
      display: 'flex',
      maxWidth: '100%',
      boxShadow: '0 8px 36px 0 rgba(0, 0, 0, 0.06)',
      overflowX: 'auto',
      padding: '0 0 8px 0',
    },
  }),
  {
    name: 'OptionalCardPreview',
  },
);

function OptionalCardPreview({ orgIconURL, message, showIndex }) {
  const classes = useStyles();
  const cardComponents = message.data.elements.map((element, index) => {
    return (
      <OptionalCard
        key={`preview-${message.index}-card-${index}`}
        data={element}
        messageIndex={message.index}
        index={index}
        showIndex={showIndex}
      />
    );
  });
  return (
    <div className={classes.root}>
      <ImageDisplay
        style={{ objectFit: 'cover', borderRadius: '50%', marginRight: 12 }}
        src={orgIconURL}
        width={44}
        height={44}
      />
      <div className={classes.content}>{cardComponents}</div>
    </div>
  );
}

export default OptionalCardPreview;
